export const BRAND = {
  name: 'ATITHI',
  tagline: 'TRAVEL & TAXI SERVICE',
  subtitle: "India's Trusted Travel Partner",
  logoSrc: `${process.env.PUBLIC_URL}/atithi-logo.png`,
  colors: {
    navy: '#1B2D5E',
    navyHover: '#152448',
    navyDark: '#121E3D',
    saffron: '#E8651A',
    saffronHover: '#D45A10',
    gold: '#D4A017',
    orange: '#E8651A',
    orangeHover: '#D45A10',
    muted: '#5A6478',
    border: '#E2E8F0',
  },
  contact: {
    phone: '+919727758111',
    phoneDisplay: '+91 97277 58111',
    email: 'ranamahipal297@gmail.com',
    address: 'Atithi Travel, B/h Krishna Colour Lab, Jin Compound, Surendranagar',
  },
};
